export type GetDeploymentRequestResponse = {
  deploymentRequestDetail: DeploymentRequestDetail;
  tckIdList: TckId[];
};

export type DeploymentRequestDetail = {
  dplymntReqSeq: string;
  reverttargetdplymntReqSeq: string;
  jediPjtId: string;
  jediPjtName: string;
  jediPjtDescription: string;
  dplymntSts: string;
  dplymntStsTypeName: string;
  dplymntResultKbn: string;
  dplymntResultKbnName: string;
  dplymntType: string;
  dplymntTypeName: string;
  dplymntEnv: string;
  envId: string;
  reqUser: string;
  reqDtime: string;
  scheDtime: string;
  dplymntAprvr: string;
  aprvrDtime: string;
  rvwCmnt: string;
  retryCnt: number;
  errorInfo: string;
  dplymntCmpDtime: string;
  updateDtimeTDplymntReqMng: string;
};

type TckId = {
  tckId: string;
};
